
(function(){
  if(window.__MC_NOIR_VANITY__) return;
  window.__MC_NOIR_VANITY__ = true;

  function bindVariants(root){
    root.querySelectorAll('[data-mnv-variant]').forEach(function(select){
      if(select.dataset.bound === '1') return;
      select.dataset.bound = '1';
      select.addEventListener('change', function(){
        var option = select.options[select.selectedIndex];
        document.querySelectorAll('[data-mnv-variant]').forEach(function(other){
          if(other !== select){
            for(var i=0;i<other.options.length;i++){
              if(other.options[i].value === option.value){ other.selectedIndex=i; break; }
            }
          }
        });
        document.querySelectorAll('[data-mnv-price]').forEach(function(el){
          if(option.dataset.price) el.textContent = option.dataset.price;
        });
        document.querySelectorAll('[data-mnv-compare]').forEach(function(el){
          el.textContent = option.dataset.compare || '';
        });
      });
    });
  }

  function bindSliders(root){
    root.querySelectorAll('[data-mnv-slider]').forEach(function(slider){
      if(slider.dataset.bound === '1') return;
      slider.dataset.bound = '1';
      var track = slider.querySelector('.mnv__track');
      var cards = Array.from(slider.querySelectorAll('.mnv__review'));
      var prev = slider.querySelector('.mnv__arrow--prev');
      var next = slider.querySelector('.mnv__arrow--next');
      var dots = slider.querySelector('.mnv__dots');
      if(!track || !cards.length) return;
      var index = 0;

      function visibleCount(){
        if(window.innerWidth <= 749) return 1;
        if(window.innerWidth <= 900) return 2;
        if(window.innerWidth <= 1050) return 3;
        return 4;
      }
      function maxIndex(){ return Math.max(cards.length - visibleCount(), 0); }
      function goTo(i){
        index = Math.max(0, Math.min(i, maxIndex()));
        var target = cards[index];
        if(target) track.scrollTo({left: target.offsetLeft - track.offsetLeft, behavior:'smooth'});
        updateDots();
      }
      function updateDots(){
        if(!dots) return;
        dots.querySelectorAll('.mnv__dot').forEach(function(dot,i){
          dot.classList.toggle('is-active', i === index);
        });
      }
      function buildDots(){
        if(!dots) return;
        dots.innerHTML = '';
        for(var i=0;i<=maxIndex();i++){
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'mnv__dot';
          dot.setAttribute('aria-label','Go to review '+(i+1));
          (function(n){ dot.addEventListener('click',function(){ goTo(n); }); })(i);
          dots.appendChild(dot);
        }
        updateDots();
      }

      if(prev) prev.addEventListener('click',function(){ goTo(index <= 0 ? maxIndex() : index - 1); });
      if(next) next.addEventListener('click',function(){ goTo(index >= maxIndex() ? 0 : index + 1); });
      track.addEventListener('scroll',function(){
        var nearest = 0;
        var distance = Infinity;
        cards.forEach(function(card,i){
          var d = Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft);
          if(d < distance){ distance = d; nearest = i; }
        });
        index = Math.min(nearest, maxIndex());
        updateDots();
      },{passive:true});
      window.addEventListener('resize',function(){ buildDots(); goTo(index); });
      buildDots();
    });
  }

  function init(root){
    bindVariants(root || document);
    bindSliders(root || document);
  }

  document.addEventListener('DOMContentLoaded',function(){ init(document); });
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();
